'use client';

import { useState } from 'react';

interface Props {
  names: string[];
  onSelect: (name: string) => void;
}

export default function NameSelector({ names, onSelect }: Props) {
  const [search, setSearch] = useState('');
  const filtered = names.filter(n =>
    n.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full max-w-md">
      <label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300 mb-1">
        Select your name:
      </label>
      <input
        type="text"
        placeholder="Search names..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="w-full px-3 py-2 border border-zinc-300 dark:border-zinc-700 rounded-md bg-white dark:bg-zinc-900 text-zinc-900 dark:text-zinc-100 mb-2"
      />
      <div className="max-h-64 overflow-y-auto border border-zinc-200 dark:border-zinc-800 rounded-md">
        {filtered.length === 0 && (
          <p className="px-3 py-2 text-sm text-zinc-500">No names found</p>
        )}
        {filtered.map(name => (
          <button
            key={name}
            onClick={() => onSelect(name)}
            className="w-full text-left px-3 py-2 hover:bg-zinc-100 dark:hover:bg-zinc-800 text-sm text-zinc-800 dark:text-zinc-200 border-b border-zinc-100 dark:border-zinc-800 last:border-0"
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
}